// Whole-dollar currency formatting for the risk meter's financial table and edit dialog

const wholeDollars = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
});

export const formatCurrency = (amount: number | null | undefined): string =>
    amount === null || amount === undefined ? '-' : wholeDollars.format(amount);

// DevExtreme NumberBox format string - matches formatCurrency
export const CURRENCY_FORMAT = '$#,##0';
